import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ProjectService } from 'src/app/services/project.service';
import { ApiInit } from 'src/app/utils/api-init';
import { SearchItemComponent } from '../../components/search-item/search-item.component';
import { Suggestion } from 'src/app/interfaces/suggestion';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { Router } from '@angular/router';
import { TargetPickerService } from '../../services/target-picker.service';
import { OnboardingService } from 'src/app/services/onboarding.service';
import { TranslateModule } from '@ngx-translate/core';
import { SearchEmptyComponent } from '../../components/search-empty/search-empty.component';
import { NgIf, NgFor } from '@angular/common';
import { LoaderComponent } from '../../components/loader/loader.component';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.page.html',
  standalone: true,
  imports: [
    LoaderComponent,
    NgIf,
    NgFor,
    SearchItemComponent,
    SearchEmptyComponent,
    TranslateModule,
    IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonFooter,
  ],
})
export class SuggestionPage implements OnInit {
  projectsLoaded: boolean = false;
  suggestions: Suggestion[] = [];
  deviceDataLoaded: boolean = false;
  noAddresses: boolean = false;
  appName: string;
  @ViewChildren(SearchItemComponent)
  searchItemElements: QueryList<SearchItemComponent>;
  disabledCount: number = 0;
  pickingTarget: boolean = false;

  constructor(
    private router: Router,
    private apiInit: ApiInit,
    private projectService: ProjectService,
    private targetPickerService: TargetPickerService,
    private app: CurrentWhiteLabelApplication,
    private onboardingService: OnboardingService
  ) {
    this.appName = this.app.getName();
    this.targetPickerService.starDone$.subscribe(() => {
      this.disabledCount--;
      this.pickingTarget = false;
    });
    this.projectService.starChanged$.subscribe(
      () => (this.pickingTarget = false)
    );
  }

  ngOnInit() {
    this.apiInit.watch(() => {
      this.loadProjects();
    });
  }

  async loadProjects() {
    this.suggestions = await this.projectService.getProjectsByClosestLocation();

    if (
      this.suggestions.length <= 5 &&
      this.suggestions[0]?.location === null
    ) {
      this.noAddresses = true;
    }

    this.projectsLoaded = true;
  }

  search() {
    this.router.navigate(['onboarding', 'suggestion', 'search'], {
      replaceUrl: true,
    });
  }

  complete() {
    this.onboardingService.obnoardingFinished$.next(true);
    this.router.navigate([''], { replaceUrl: true });
  }

  skip() {
    this.onboardingService.obnoardingFinished$.next(true);
    this.router.navigate([''], { replaceUrl: true });
  }

  disable() {
    this.disabledCount++;
    this.pickingTarget = true;
  }
}
